let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cCg0b")).then(() => parcelRequire('j2DXz'));